import React from "react";
import { Link } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ROLE_TO_HELP_PROFILE, PAGE_HELP_SLUGS } from "@/lib/dict";

/**
 * Small discreet "Besoin d'aide ?" link for business pages (Actifs, Sinistres, Attestations).
 * Deep-links straight to the relevant Centre d'aide article for the current user's profile;
 * falls back to the plain Centre d'aide (own profile) if no mapping exists for this page.
 */
export default function ContextualHelpLink({ page }) {
  const { user } = useAuth();
  const profile = ROLE_TO_HELP_PROFILE[user?.role] || "managers";
  const slug = PAGE_HELP_SLUGS[page]?.[profile];
  const to = slug ? `/help-center?article=${slug}` : "/help-center";
  return (
    <Link
      to={to}
      data-testid={`contextual-help-${page}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-[#023E73] transition-colors"
    >
      <CircleHelp size={14} /> Besoin d'aide ?
    </Link>
  );
}
